import React from 'react';
import Link from 'next/link';
import styles from '../../styles/compare/OfferInfo.module.scss';
import Image from 'next/image';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import {getLoanInterestType} from '../../utils/compare/CompareUtilities';
import * as gtag from '../../cookie/lib/gtag';

const LeasingInfo = (props) => {
    const { details, viewDetails, sort, applyParams, product} = props;
    const handleViewDetails = () => {
        viewDetails(details.id);
    }

    let providerCol =   <Col xs="12" md="4">
                            {details.showLogo ?
                            <Image src={details.providerLogo} 
                                    height={details.logoSize.height}
                                    width={details.logoSize.width}
                                    alt={details.provider}
                            /> 
                            : 
                            <p className="mb-0 font-weight-bold">{details.provider}</p> }

                            <p className={`${styles.productName} mb-0`} >{details.product}</p>
                        </Col>;


    let aprColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                DAE
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='apr' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 2}).format(details.apr)} %
                            </p>
                        </Col>
                        ;
    let totalCostColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                Suma de plată 
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='totalAmount' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.totalAmount)} {details.currency}
                            </p>
                        </Col>
                        ;
    let paymentColumn = 
                        <Col xs="4" className="p-2 text-center">
                            <p className={`${styles.indicator} `}>
                                Rata lunară
                            </p>
                            <p className={`${styles.indicatorVal} ${sort=='monthlyPayment' ? styles.active : ''}  mb-0`} suppressHydrationWarning>
                                {Intl.NumberFormat('fr', {maximumFractionDigits: 0}).format(details.monthlyPayment)} {details.currency}
                            </p>
                            <p className={`mb-0 ${styles.rateType} `}>{getLoanInterestType(details.rateType)}</p>
                        </Col>
                        ;

    let detailsCol = <Col xs="6" md="4" className="py-3 text-center">
                        <Button variant="link" aria-label="Detalii" onClick={handleViewDetails}>
                            <u>Detalii</u>
                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />
                        </Button>
                    </Col>;

    let relOpennerTag;
    if (details.hasOwnProperty('apply')) {
        relOpennerTag = details.apply.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } else if (details.hasOwnProperty('webLink')){
        relOpennerTag = details.webLink.indexOf(` ${process.env.NEXT_PUBLIC_SITE_URL} `) > -1 ? '' : 'noopener';
    } {
        relOpennerTag = '';
    }

    const onApply = () => {
        if (window.location.hostname.indexOf('conso.ro')>1) {
            gtag.event('Apply', {
                provider: details.provider,
                product: product,
            });
        } else {
            console.log("beta");
        }
     }

    let applyCol = details.hasOwnProperty('apply') &&
                    <Col xs="6" md="4" className="d-flex justify-content-center align-items-center mt-2">
                        <Link
                            href={ details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? 
                                    `${details.apply}${applyParams.length>0 ? '?'+ applyParams : ''}`
                                    : 
                                    details.apply
                                }
                            className="btn btn-primary"
                            rel={relOpennerTag}
                            target={details.apply.indexOf(`${process.env.NEXT_PUBLIC_SITE_URL}`) > -1 ? '_self' : '_blank'}
                            onClick={onApply}>
                            Solicită ofertă
                                                            <FontAwesomeIcon className="ms-2" icon={faChevronRight} height="16" width="16" />

                        </Link>
                    </Col>;



    return (
        <div className={`${styles.root} mb-5 p-3`}>
            <Row className={`${styles.product} justify-content-between mb-0`} >
                {providerCol}
               
            </Row>
            <Row className={`${styles.product} mb-0 justify-content-center`}>  
                {aprColumn}
                {totalCostColumn}  
                {paymentColumn} 
            </Row>
            <Row className={ `mb-0 justify-content-between align-items-center`} >  
                {detailsCol}
                {applyCol}
            </Row>
        </div>
    );
}

export default LeasingInfo;